export const OFFLINE_BOOKING_BACKGROUND_COLOR = '#fdf0e0';
export const OFFLINE_BOOKING_ACCENT_COLOR = '#e08a1e';
